import loadable from '@loadable/component';

export const OrgDashboardIntegrationsPageContainerLoadable = loadable(
  () => import('./OrgDashboardIntegrationsPageContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardIntegrationsPageContainer,
  },
);
